import React from 'react';
import {Box, Button} from '@mui/material';
import Loading from '../Loading/Loading';
import {selectedStaff} from '../../hooks/useGetStaffId';
import {StaffSearchForm} from '../AdviserSearchForm/AdviserSearchForm';
import {handleStaffUpdate} from './helpers';
import {GetLoginInfo_getCurrentUser} from '../../schema-types/GetLoginInfo';

type AdviserSearchProps = {
  visible: boolean;
  setAdviser: React.Dispatch<React.SetStateAction<selectedStaff | null>>;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  currentUserData: GetLoginInfo_getCurrentUser;
};

const AdviserSearch = ({
  visible,
  setAdviser,
  setVisible,
  currentUserData,
}: AdviserSearchProps) => {
  if (visible) {
    return (
      <Box display="flex" justifyContent="space-between">
        <Box flex={1}>
          <StaffSearchForm
            formFields={[]}
            onStaffChange={(advisorStaff) => handleStaffUpdate(advisorStaff, setAdviser)}
          />
        </Box>
        <Box ml={3} />
        <Button
          style={{whiteSpace: 'pre'}}
          variant="outlined"
          onClick={() => setVisible(false)}
        >
          Hide search
        </Button>
        <Button
          style={{whiteSpace: 'pre'}}
          variant="outlined"
          onClick={() => {
            setVisible(false);
            setAdviser(currentUserData);
          }}
        >
          Reset Search
        </Button>
      </Box>
    );
  }

  return <Loading>Loading staff...</Loading>;
};

export default AdviserSearch;
